import { render, staticRenderFns } from "./SelectablesFieldsPopup.vue?vue&type=template&id=67d1cd19"
import script from "./SelectablesFieldsPopup.vue?vue&type=script&lang=js"
export * from "./SelectablesFieldsPopup.vue?vue&type=script&lang=js"
import style0 from "./SelectablesFieldsPopup.vue?vue&type=style&index=0&id=67d1cd19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports